/**
 * nav
 */
import PerfectScrollbar from 'perfect-scrollbar';
import {gsap, Expo, ScrollToPlugin} from 'gsap/all';
gsap.registerPlugin(ScrollToPlugin);

export default class nav {

  constructor() {
    // クラス名
    this.id = 'c-nav';
    this.el = document.getElementById(this.id);

    if (this.el) {
      // 背景の操作
      this.init();
    }
  }

  init() {
    this.scrollToEl = [
      'p-tapestry',
      'p-clearfile',
      'p-token__ninjameshi',
      'p-token__osake',
      'p-glassSet',
      'p-token__puromaido',
    ];
    this.isShow = false;

    // gsap timeline
    this.initTimeline();

    /*// MAPスクロール
    this.swiper = new Swiper(this.el.querySelector('.swiper-container'), {
      direction: 'vertical',
      slidesPerView: 'auto',
      freeMode: true,
      //freeModeMomentum: false,
      //freeModeMomentumBounce: false,
      scrollbar: {
        el: '.c-nav__menuScrollbar',
        hide: false,
        draggable: true,
      },
      mousewheel: true,
      updateOnWindowResize: true,
    });*/
    const container = document.querySelector('#swiper-container');
    const ps = new PerfectScrollbar(container);

    // イベント
    document.getElementById('c-nav__menuClose').addEventListener('click', this.toggle.bind(this));
    document.getElementById('c-nav__bg').addEventListener('click', this.hide.bind(this));
    this.btns = document.getElementById('c-nav__menuWrap__list').querySelectorAll('a');
    this.btns.forEach((el, i) => {
      el.addEventListener('click', this.scrollTo.bind(this, [this.scrollToEl[i]]));
    });
  }

  scrollTo(e) {
    requestAnimationFrame(this.hide.bind(this));

    const offset = this.getOffset(document.getElementById(e[0]));
    let posY =  offset.offset.top;
    
    if (e[0] === 'p-token__osake') {
      posY = posY - ((120 / 750) * window.innerWidth);
    } else if (e[0] === 'p-glassSet') {
      posY = posY - ((300 / 750) * window.innerWidth);
    }

    gsap.to(window, {duration: 1.0, scrollTo: {y: posY, autoKill: false, ease: Expo.easeOut}})
  }

  initTimeline() {
    // 開く
    const bg = this.el.querySelector('.c-nav__bg');
    this.tlShow = gsap.timeline({paused: true, onComplete: this.showComp.bind(this)});
    this.tlShow.addLabel('start', 0);

    this.tlShow.set(this.el, {width: '100%'}, 'start');
    this.tlShow.set(bg, {pointerEvents: 'auto', visibility: 'visible', opacity: 0}, 'start');

    this.tlShow.to(this.el.querySelector('.c-nav__menu'), {
      duration: 1.2,
      x: '0%',
      ease: Expo.easeOut
    }, 'start+=0.1');

    this.tlShow.to(bg, {
      duration: 1.2,
      opacity: 1,
      ease: Expo.easeOut
    }, 'start+=0.1');

    // 閉じる
    this.tlHide = gsap.timeline({paused: true, onComplete: this.hideComp.bind(this)});
    this.tlHide.addLabel('start', 0);

    //this.tlHide.set(this.el, {width: '100%'}, 'start');

    this.tlHide.to(this.el.querySelector('.c-nav__menu'), {
      duration: 0.7,
      x: '-100%',
      ease: Expo.easeOut
    }, 'start');

    this.tlHide.to(this.el.querySelector('.c-nav__bg'), {
      duration: 0.7,
      opacity: 0,
      ease: Expo.easeOut
    }, 'start+=0.1');
  }

  toggle() {
    if (this.isShow) {
      // 閉じる
      this.hide();
    } else {
      // 開く
      this.show();
    }
  }

  show() {
    this.isShow = true;
    this.tlHide.kill();
    this.tlShow.play(0);
  }

  showComp() {

  }

  hide() {
    this.isShow = false;
    this.tlShow.kill();
    this.tlHide.play(0);
  }

  hideComp() {
    gsap.set(this.el, {clearProps: 'all'});
    gsap.set(this.el.querySelector('.c-nav__menu'), {clearProps: 'all'});
    gsap.set(this.el.querySelector('.c-nav__bg'), {clearProps: 'all'});
  }

  getOffset(selector) {
    let rect = null;
    if (typeof selector === 'string') {
      rect = document.querySelector(selector).getBoundingClientRect();
    } else if (selector !== undefined) {
      rect = selector.getBoundingClientRect();
    }

    if (rect) {
      return {
        orig: rect,
        offset: {
          top: rect.top + this.getScrollTop(),
          left: rect.left
        }
      }
    }

    return null;
  }

  getScrollTop() {
    return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
  }
}
